import axios from 'axios';

const AI_BASE_URL = process.env.REACT_APP_QMETRIX_AI_URL || 'http://127.0.0.1:8000';

const UPLOAD_ENDPOINT = `${AI_BASE_URL}/api/v1/ai/upload-analysis`;
const STATUS_ENDPOINT = `${AI_BASE_URL}/api/v1/ai/upload-analysis/status`;

const buildError = (error, context = {}) => {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.detail ||
    error?.message ||
    'Unable to upload the screenshot right now.';

  console.error('Upload Failed', {
    endpoint: context.endpoint || UPLOAD_ENDPOINT,
    payloadKeys: context.payloadKeys || [],
    status: error?.response?.status || null,
    response: error?.response?.data || null,
    message: error?.message || null,
  });

  const normalizedError = new Error(message);
  normalizedError.cause = error;
  normalizedError.status = error?.response?.status || null;
  return normalizedError;
};

const getSessionValue = (key) => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.sessionStorage.getItem(key);
};

const buildRequestHeaders = () => {
  const token = getSessionValue('qmetrix-token');
  return token ? { 'qmetrix-token': token } : {};
};

export const uploadScreenshot = async (formData, options = {}) => {
  if (!(formData instanceof FormData)) {
    throw new Error('Please choose a screenshot to upload.');
  }

  const payloadKeys = [];
  for (const key of formData.keys()) {
    payloadKeys.push(key);
  }

  console.log('Upload Endpoint:', UPLOAD_ENDPOINT);
  console.log('FormData Keys:', payloadKeys);

  try {
    const headers = {
      ...buildRequestHeaders(),
      ...(options.headers || {}),
    };
    delete headers['Content-Type'];
    delete headers['content-type'];

    const response = await axios.post(UPLOAD_ENDPOINT, formData, {
      params: options.params,
      headers,
      onUploadProgress: options.onUploadProgress,
    });

    return response.data;
  } catch (error) {
    throw buildError(error, {
      endpoint: UPLOAD_ENDPOINT,
      payloadKeys,
    });
  }
};

export const getAnalysisStatus = async (analysisId) => {
  if (!analysisId) {
    throw new Error('Missing analysis id.');
  }

  try {
    const response = await axios.get(`${STATUS_ENDPOINT}/${analysisId}`);
    return response.data;
  } catch (error) {
    throw buildError(error, {
      endpoint: `${STATUS_ENDPOINT}/${analysisId}`,
      payloadKeys: [],
    });
  }
};

export const uploadScreenshotAnalysis = uploadScreenshot;

export default {
  uploadScreenshot,
  getAnalysisStatus,
  uploadScreenshotAnalysis,
};
